package com.rosario.juridico.navigation

import io.ktor.http.encodeURLQueryComponent

object Routes {
    // Principal
    const val INICIO = "inicio"
    const val LOGIN = "login?register={register}"

    // IA
    const val CONSULTA = "consulta"
    const val ASISTENTE_REDACCION = "asistente_redaccion"

    // Calculadoras
    const val CALCULADORA_DIAS = "calculadora_dias"
    const val CALCULADORA_VENCIMIENTOS = "calculadora_vencimientos"
    const val CALCULADORA_HONORARIOS = "calculadora_honorarios"
    const val CALCULADORA_INCAPACIDAD = "calculadora_incapacidad"

    // Documentos y modelos
    const val DOCUMENTOS = "documentos"
    const val MODELOS_ALQUILER = "modelos_alquiler"
    const val CODIGOS_SELLADOS = "codigos_sellados"
    const val GUIA_INFO = "guia_info?focusId={focusId}"
    const val VISOR_PDF = "visor_pdf/{titulo}/{resId}"

    // Generador de contratos
    const val GENERADOR_CONTRATO = "generador_contrato"
    const val GENERADOR_CONTRATO_CON_CLAVE = "generador_contrato?clave={clave}"

    // Marketplace
    const val REGISTRO_ABOGADO = "registro_abogado"
    const val PUBLICAR_CONSULTA = "publicar_consulta"
    const val LISTADO_CONSULTAS = "listado_consultas"
    const val MIS_CONSULTAS = "mis_consultas"
    const val DETALLE_CONSULTA = "detalle_consulta/{consultaId}"
    const val CHAT = "chat/{consultaId}"
    const val PERFIL_ABOGADO = "perfil_abogado"
    const val CALCULADORA_ECONOMICA = "calculadora_economica"
    const val PANEL_ADMIN = "panel_admin"
    const val DIRECTORIO_AVVO = "directorio_avvo"
    const val PLANILLA_MEDIACION = "planilla_mediacion"

    // Nuevas rutas temporales para el menú extendido
    const val TASA_JUSTICIA = "tasa_justicia"
    const val VALOR_JUS = "valor_jus"
    const val INDICE_CAC = "indice_cac"
    const val IPC_INFLACION = "ipc_inflacion"
    const val MEU_TRIBUNALES = "meu_tribunales"
    const val INFO_SCREEN = "info_screen"

    // Agenda de Expedientes
    const val AGENDA_EXPEDIENTES = "agenda_expedientes"
    const val AGENDA_PROMESA = "agenda_promesa"
    const val DETALLE_EXPEDIENTE = "detalle_expediente/{expedienteId}"
    const val NUEVO_EXPEDIENTE = "nuevo_expediente"

    // Premium y Pagos
    const val PAYWALL = "paywall"
    const val PAYMENT_SUCCESS = "payment_success"

    // Helpers para navegar con argumentos
    fun login(register: Boolean = false) = "login?register=$register"
    fun consulta(query: String? = null) = if (!query.isNullOrBlank()) "consulta?query=${query.encodeURLQueryComponent()}" else CONSULTA
    fun visorPdf(titulo: String, resId: String) = "visor_pdf/$titulo/$resId"
    fun detalleConsulta(consultaId: String) = "detalle_consulta/$consultaId"
    fun chat(consultaId: String) = "chat/$consultaId"
    fun generadorContrato(clave: String? = null) =
        if (clave != null) "generador_contrato?clave=$clave" else GENERADOR_CONTRATO
    fun detalleExpediente(expedienteId: String) = "detalle_expediente/$expedienteId"
    fun guiaInfo(focusId: String? = null) = if (focusId != null) "guia_info?focusId=$focusId" else "guia_info"
}
